/**
 * Shared constants for SearchCenter feature
 */

/**
 * Maximum number of case entries to store in promptPlaceholders array.
 * When this limit is reached, the oldest entry (LRU - Least Recently Used) is removed.
 */
export const MAX_PROMPT_PLACEHOLDERS_ENTRIES = 250;
